import { render, staticRenderFns } from "./addresses.component.vue?vue&type=template&id=e0ec2414&"
import script from "./addresses.component.vue?vue&type=script&lang=ts&"
export * from "./addresses.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "addresses.component.vue"
export default component.exports